import { render, staticRenderFns } from "./bottom-info.vue?vue&type=template&id=48f58b9e&scoped=true"
import script from "./bottom-info.vue?vue&type=script&lang=js"
export * from "./bottom-info.vue?vue&type=script&lang=js"
import style0 from "./bottom-info.vue?vue&type=style&index=0&id=48f58b9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f58b9e",
  null
  
)

export default component.exports